<div class="comments">
  <div class="row d-flex ticket-form comment-form" *ngIf="showAddComment()">
    <div class="col-12 col-sm-6 col-md-6 col-lg-6">
      <app-dynamic-form
        *ngIf="questions"
        [questions]="questions"
        saveLabel="Add comment"
        (formSubmit)="onSubmit($event)"
      >
      </app-dynamic-form>
    </div>
  </div>
  <div *ngIf="comments?.length; else noComments" class="ticket-comments-list">
    <div class="row d-flex justify-content-left ticket-comment-sort">
      <span class="sort-label"> Sort by date: </span>
      <button class="edit" (click)="toggleSort()" color="primary" mat-icon-button>
        <mat-icon>{{ sort.icon }}</mat-icon
        ><span class="mat-h3"> {{ sort.label }}</span>
      </button>
    </div>
    <mat-card
      *ngFor="let comment of comments"
      class="ticket-comment-card"
      [ngClass]="!comment.isPublicInternal ? 'private-comment' : ''"
    >
      <mat-card-title-group>
        <div class="ticket-information-container">
          <mat-card-title>
            <div class="name-tooltip">
              <div>
                {{ comment.name }}
              </div>
              <ng-container *ngIf="!comment.isPublicInternal">
                <div>
                  <mat-icon [matTooltip]="'This is hidden for company users'" matPreffix>info</mat-icon>
                </div>
              </ng-container>
            </div>
          </mat-card-title>
          <mat-card-subtitle>{{ comment.createdAt | date: "medium":"EDT" }} - {{ comment.email }}</mat-card-subtitle>
        </div>
      </mat-card-title-group>
      <mat-divider></mat-divider>
      <mat-card-content>
        <div class="comment-container">
          <p [innerHTML]="comment.commentHtml"></p>
        </div>
        <ng-container *ngIf="comment.commentAttachments?.length">
          <div class="attachments-container">
            <mat-divider></mat-divider>
            <ng-container *ngFor="let attachment of comment.commentAttachments; let attachmentIndex = index">
              <p>
                <b>File {{ attachmentIndex + 1 }}: </b
                ><a target="_blank" href="{{ attachment.providerUrl }}">{{ attachment.fileName }}</a>
              </p>
            </ng-container>
          </div>
        </ng-container>
      </mat-card-content>
    </mat-card>
    <app-paginator [length]="meta.totalItems" [pageSizeOptions]="[20, 30, 50]" (changeEvent)="onPaginateChange($event)">
    </app-paginator>
  </div>

  <ng-template #noComments>
    <div class="empty-comments">
      <h4 *ngIf="!loading">No comments assigned for this ticket</h4>
    </div>
  </ng-template>
</div>
